import { Button, Heading, Text, Callout } from '@expressable/syntax-ds';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { TimeOptionValue } from 'components/TimeOptionsCheckboxes/TimeOptionsCheckboxes';
import { EvaluationScheduleFormType } from 'domains/signupDirect/schemas/evaluationScheduleSchema';

type Props = {
  onTimeOptionsChange: (value: TimeOptionValue) => void;
  availableTherapistsCount: number;
  currentDay: string;
};

export const NoTimeOptionsMatches: FC<Props> = ({ onTimeOptionsChange, availableTherapistsCount, currentDay }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext<Partial<EvaluationScheduleFormType>>();

  const handleResetFilters = () => {
    const resetValue: TimeOptionValue = {
      earlyMorning: false,
      morning: false,
      afternoon: false,
      evening: false,
    };
    setValue('timeOptions', resetValue);
    onTimeOptionsChange(resetValue);
  };

  return (
    <Callout type="info">
      <div className="flex flex-col gap-e24">
        <Heading level="h4" noDefaultMargins>
          {t('directSignup.schedule.single.timeOptions.noMatches.title')}
        </Heading>
        <Text>
          {t('directSignup.schedule.single.timeOptions.noMatches.subtitle')}
          <Button variant="link" onClick={handleResetFilters}>
            {t('directSignup.schedule.single.timeOptions.noMatches.resetFilters')}
          </Button>
        </Text>
        {t('directSignup.schedule.single.timeOptions.noMatches.therapistsAvailableAtDifferentTime', {
          count: availableTherapistsCount,
          date: currentDay,
        })}
      </div>
    </Callout>
  );
};
